<script>
export default {
    name: 'MovedNotice',
    props: {
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
}
</script>

<template>
    <div class="moved">
        <div class="sa-card moved__cell">
            <h1>{{ title }} wurde verschoben</h1>
            <p class="text-muted">Dieser Bildschirm wird nicht mehr gepflegt. Öffne {{ title }} im ShiftOS Panel.</p>
            <b-button :href="url" target="_blank" variant="primary">{{ title }} öffnen</b-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.moved {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    padding: 24px var(--page-x);
}
.moved__cell {
    width: 100%;
    max-width: 420px;
    text-align: center;
}
.moved__cell h1 {
    margin-bottom: 12px;
}
.moved__cell p {
    margin-bottom: 20px;
}
</style>
